(function($) {

	'use strict';

	var init = function() {
        $(window).resize(function() {
            if($(window).width() > 992) {
                marginTop()
            }else{
                removeMarginTop()
            }
        }).resize()
	};

	var marginTop = function(){

        var testimony = $('.flex-testimony').next()
        var team = $('.flex-team--first').prev()
        testimony.css({
            'margin-top': '-300px',
            'z-index': '2',
            'position': 'relative'
        }) 

        team.css({
            'margin-bottom': '-300px',
            'position': 'relative'
        })

    };
    
    var removeMarginTop = function(){

        var testimony = $('.flex-testimony').next()
        var team = $('.flex-team').prev()
        testimony.attr("style", "")

        team.attr("style", "")

	};

	$(document).ready(function() {
		init();
	});

})(jQuery);
